// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: process.env.REACT_APP_REGION,
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    aws_appsync_region: process.env.REACT_APP_REGION,
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID,
    aws_user_pools_web_client_id: process.env.REACT_APP_CLIENT_ID,
    aws_cognito_region: process.env.REACT_APP_REGION,
    aws_mandatory_sign_in: true,
    // AppSync Events, where INNA's answers stream in. Both endpoints are
    // stack outputs - ChatEventsHttpDomain and ChatEventsRealtimeDomain.
    aws_chat_events_http_domain: process.env.REACT_APP_CHAT_EVENTS_HTTP_DOMAIN,
    aws_chat_events_realtime_domain: process.env.REACT_APP_CHAT_EVENTS_REALTIME_DOMAIN
};

export default awsmobile;
